import '../../../stylesheets/semantic-theme/definitions/modules/sidebar';

const sidebar = () => {
  const sidebarToggle = document.getElementById('js-sidebar-toggle');
  const topSidebar = document.getElementById('js_top_sidebar');

  if (sidebarToggle && topSidebar) {
    sidebarToggle.addEventListener('click', () => {
      topSidebar.classList.toggle('visible');
    })
  }
};

export default sidebar;
